import * as Sentry from '@sentry/react';
import { useNavigate } from 'react-router';
import { useNotification } from '@/context/notification';
import {
  CertificateSources,
  useGetCertificateUrl,
} from '@/data/courses/certificate';

export const useGenerateCertificate = (courseId: number) => {
  const { mutate: getCertificateUrl, isPending: loadingCertificate } =
    useGetCertificateUrl(courseId, CertificateSources.Eduplay);
  const navigate = useNavigate();
  const { toast } = useNotification();

  const handleClose = () => {
    navigate('/meu-aprendizado');
  };

  const onError = (error?: Error) => {
    toast({
      content: 'Não foi possível gerar o certificado.',
      type: 'error',
    });
    Sentry.captureException(
      error || new Error('Não foi possível gerar o certificado.')
    );
  };

  const viewCertificate = () => {
    getCertificateUrl(undefined, {
      onSuccess: ({ data }) => {
        if (!data?.certificate_url) {
          onError();
          return;
        }
        window.open(data.certificate_url, '_blank');
        handleClose();
      },
      onError,
    });
  };

  return {
    viewCertificate,
    loadingCertificate,
  };
};
